<template>
  <div
    v-if="incomingCallDialog"
    v-draggable="{resetInitialPos: true}"
    class="incoming-call"
  >
    <div class="incoming-call-header">
      Incoming Call
    </div>
    <el-tag v-if="transferrer" type="warning"  style="width: 100%; border-radius: 0;">
      <div class="flex justify-center align-center">
        <i class="el-icon-warning"  style="margin-right: 4px;" />
        <h4 class="transfer mt-0 mb-0">
          Transfer By: {{transferrer}}
        </h4>
      </div>
    </el-tag>
    <div class="incoming-call-modal">
      <div class="incoming-call-container">
        <div class="incoming-caller-info">
          <div class="avatar-group">
            <div class="contact-avatar" v-if="contactAvatar">
              <img :src="contactAvatar" :alt="incomingCaller" :title="incomingCaller" />
            </div>
            <div class="contact-avatar" v-else>
              {{nameFormatter(incomingCaller).substring(0,1).toUpperCase()}}
            </div>
          </div>
          <div class="incoming-caller-stats">
            <p class="caller-name"><strong>{{nameFormatter(incomingCaller)}}</strong></p>
            <p class="caller-number">{{numberFormatter(incomingPhoneNumber)}}</p>
          </div>
        </div>
        <div class="incoming-actions">
          <div class="incoming-accept-button">
            <div class="button-wrapper" @click="acceptCall">
              <v-svg class="voxo-green mr-10" sprite="call"/>
              <strong>Accept</strong>
            </div>
          </div>
          <div class="incoming-decline-button">
            <div class="button-wrapper" @click="declineCall">
              <v-svg class="voxo-red mr-10" sprite="call-block"/>
              <strong>Decline</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {globalEventBus} from '../../../../globalEventBus';
import feathersClient from "../../../../feathers/feathers-client";
import {Draggable} from 'draggable-vue-directive';
import { phoneNumberFormatter } from "@/globals/globals";


export default {
  name: "IncomingCall",
  props: {
    modalHandleId: {required: true}
  },
  directives: {
    Draggable,
  },
  data() {
    return {
      incomingCallDialog: false,
      incomingCaller: 'James Harrod',
      incomingPhoneNumber: '1001',
      transferrer: null,
      contactAvatar: null,
      callStatus: false,
      messageVisible: false,
      innerVisible: false,
      optionsVisible: false,
      customReminder: false,
      reminderTime: '',
      reminderMessage: '',
      message: '',
      newCaller: 'John Smith',
      newCallerPhoneNumber: '123-456-7890',
      jsep: null,
      sipHandle: null
    }
  },
  computed: {
    ...mapGetters('mycurrentcalls', {currentCallList: 'find'}),
    ...mapGetters('phonebook-entries', {getPhonebookEntries: 'find'}),
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    },
    audioInputDevice(){
      return this.$store.state.audioInputDeviceId;
    },
    user(){
      return this.$store.state.auth.user;
    },
    inboundRingVolume(){
      return this.$store.state.inboundRingVolume;
    },
    callWaitingVolume(){
      return this.$store.state.callWaitingVolume;
    }
  },
  watch: {
    softphoneEnabled(){
      if(this.softphoneEnabled){
        this.registerSoftPhoneEvents();
      } else{
        this.killSoftphoneEvents();
      }
    }
  },
  methods: {
    acceptCall() {
      this.$emit('acceptCall', this.sipHandle);
      this.incomingCallDialog = false;
      this.clearPushNotify();
      setTimeout(this.flagSoftphone, 500);
    },
    declineCall() {
      this.$emit('declineCall', this.sipHandle)
      this.incomingCallDialog = false;
      this.clearPushNotify();
    },
    async clearPushNotify(){
      try{
        const reg = await navigator.serviceWorker.getRegistration();
        const notifications = await reg.getNotifications({
          includeTriggered: true
        });
        notifications.forEach((notification) => {
          notification.close();
        });
      } catch (e){
        console.log(e);
      }
    },
    flagSoftphone(){
      //so a couple things to do here. we need to flag this current call as softphone and be sure all the other are onHold in UI
      const calls = this.currentCallList().data;
      if(calls.length){
        for(let i = 0; i < calls.length; i++){
          const {channel, cidnum, softphoneCall} = calls[i];
          if(cidnum === this.incomingPhoneNumber && !softphoneCall){
            const updateData = {
              channel,
              softphoneCall: true,
              sipHandle: this.sipHandle,
              onHold: false,
              answered: true,
              buttonsReady: true
            }
            this.$store.commit('mycurrentcalls/updateItem', updateData);
          } else{
            this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: true});
          }
        }
      }
    },
    numberFormatter(number) {
      return number ? phoneNumberFormatter(number) : number;
    },
    nameFormatter(name){
      return name ? name.replace(/['"]+/g, '') : 'Unknown';
    },
    async getAvatar(){
      const contact = await feathersClient.service('extensions').find({
        query: {
          tenantId: this.user.myExtension.tenantId,
          number: this.incomingPhoneNumber
        }
      });
      if(contact.length){
        this.contactAvatar = contact[0].avatarPath
      }
    },
    getDirectoryName(){
      if(!this.contactAvatar){
        const contact = this.getPhonebookEntries({
          query: {
            "PHONE1": this.incomingPhoneNumber
          }
        }).data;
        if(contact.length){
          this.incomingCaller = contact[0].NAME;
        }
      }
    },
    registerSoftPhoneEvents(){
      globalEventBus.$on('softphoneIncomingCall-'+this.modalHandleId, (evt) => {
        const {transferrer, cidName, cidNum} = evt;

        this.sipHandle = evt;
        this.incomingCaller = cidName;
        this.incomingPhoneNumber = cidNum;
        this.transferrer = transferrer;
        this.contactAvatar = null;
        this.getAvatar();
        this.getDirectoryName();
        this.incomingCallDialog = true;

        //check if already on softphone call
        const calls = this.currentCallList({
          query: {
            softphoneCall: true
          }
        }).data;
        if(calls.length){
          const audioWaiting = document.getElementById('call-waiting-sound').querySelector('audio');
          audioWaiting.volume = this.callWaitingVolume;
          audioWaiting.play();
        } else{
          const audioRing = document.getElementById('call-ringing').querySelector('audio');
          audioRing.volume = this.inboundRingVolume;
          audioRing.play();
        }

      });
      globalEventBus.$on('softphoneCallHangup-'+this.modalHandleId, async () => {
        this.incomingCallDialog = false;
        this.destroyAndRecreateAudio('call-ringing');
        this.destroyAndRecreateAudio('outbound-call-ringing');

        const endAudio = document.getElementById('call-ended').querySelector('audio');
        await endAudio.play();
      });
      globalEventBus.$on('softphoneCallAccepted-'+this.modalHandleId, () => {
        this.incomingCallDialog = false;
        this.destroyAndRecreateAudio('call-ringing');
        this.destroyAndRecreateAudio('outbound-call-ringing');
      });
      globalEventBus.$on('pushAcceptCall-'+this.modalHandleId,  async () => {
        this.acceptCall();
      });
      globalEventBus.$on('pushDeclineCall-'+this.modalHandleId, () => {
        this.declineCall();
      });
      globalEventBus.$on('headsetAnswerCall-'+this.modalHandleId, () => {
        this.acceptCall()
      });
      globalEventBus.$on('headsetRejectCall-'+this.modalHandleId, () => {
        this.declineCall();
      })
    },
    destroyAndRecreateAudio(audioId) {
      const audioContainer = document.getElementById(audioId);
      const oldAudio = audioContainer.querySelector('audio');

      if (oldAudio) {
        // Stop the audio completely
        oldAudio.pause();
        oldAudio.currentTime = 0;
        oldAudio.src = '';

        // Remove the old audio element
        audioContainer.removeChild(oldAudio);
      }

      // Create a new audio element with the original source
      const newAudio = document.createElement('audio');

      switch (audioId) {
        case 'call-accepted':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/start_notification.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        case 'call-ringing':
          newAudio.src = this.$store.state.incomingRingTone;
          newAudio.type = 'audio/wav';
          newAudio.loop = true;
          break;
        case 'call-ended':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/end_notification.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        case 'outbound-call-ringing':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/phone_sounds_outgoing.mp3';
          newAudio.type = 'audio/wav';
          newAudio.loop = true;
          break;
        case 'call-waiting':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/call_waiting.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        default:
          break;
      }

      // Add the new audio element to the container
      audioContainer.appendChild(newAudio);
    },
    killSoftphoneEvents(){
      globalEventBus.$off([
        'softphoneCallHangup-'+this.modalHandleId,
        'softphoneCallAccepted-'+this.modalHandleId,
        'softphoneIncomingCall-'+this.modalHandleId,
        'pushAcceptCall-'+this.modalHandleId,
        'pushDeclineCall-'+this.modalHandleId,
        'headsetRejectCall-'+this.modalHandleId,
        'headsetAnswerCall-'+this.modalHandleId
      ]);
    }
  },
  mounted(){
    //softphone functionality if enabled
    if(this.softphoneEnabled){
      this.registerSoftPhoneEvents();
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../../../../assets/scss/_variables';
@import '../../../../assets/scss/_mixins';

.contact-avatar{
  width: 35px;
  height: 35px;
  margin-right: 10px;
}

.caller-number {
  font-size: 11px;
  text-align: left;
}

.incoming-call {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  top: 25%;
  width: 350px;
  border: 2px solid $voxo-green;
  border-radius: 8px;
  z-index: 3000;
}

.incoming-call-header{
  border-top-left-radius: 5.5px;
  border-top-right-radius: 5.5px;
}

.incoming-caller-info{
  display: flex;
  align-items: center;
  padding: 10px;
}

.incoming-actions {
  font-size: 14px;
}

.incoming-caller-stats{
  font-size: 14px;
  p{
    margin: 0;
    text-align:left;
  }
}
</style>
